import { Account } from '@tuic/api-kit';
import { PhasedBooking } from '@lib/phased-booking';
import { getTravellerCabin } from '@lib/booking';

/**
 * Returns the tariff for the given travellerId from the booking.
 * If travellerId is not provided, uses the current traveller.
 */
export const getTariff = (
  booking: PhasedBooking | Account.MyBooking2WithTravelPlanInfo,
  travellerId?: string,
): Account.Tariff | undefined => {
  const original = 'original' in booking ? booking.original : booking;

  // If travellerId is not provided, use the current traveller
  const currentTravellerId = travellerId ?? original.travellerId;

  if (typeof currentTravellerId === 'undefined') {
    return undefined;
  }

  if ('phaser' in booking && booking.phaser?.tariff) {
    return booking.phaser.tariff as Account.Tariff;
  }

  // Use getTravellerCabin which properly handles multiple active trips
  const cabin = getTravellerCabin(booking, currentTravellerId);

  return cabin?.tariff;
};

/**
 * Checks if the booking has VIP1 status.
 */
export const isVip1 = (
  booking: PhasedBooking | Account.MyBooking2WithTravelPlanInfo,
): boolean => {
  if ('phaser' in booking && typeof booking.phaser?.vip !== 'undefined') {
    return booking.phaser.vip === 1;
  }

  const original = 'original' in booking ? booking.original : booking;

  return !!original.vip1;
};

/**
 * Checks if the booking has VIP2 status.
 */
export const isVip2 = (
  booking: PhasedBooking | Account.MyBooking2WithTravelPlanInfo,
): boolean => {
  if ('phaser' in booking && typeof booking.phaser?.vip !== 'undefined') {
    return booking.phaser.vip === 2;
  }

  const original = 'original' in booking ? booking.original : booking;

  return !!original.vip2;
};
